// If doing a lazy import, must provide Suspense
import { AuthRoutes } from '../features/auth';

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
];